module.exports = __webpack_public_path__ + "img/swell-1.ef66ca7d.jpg";